import request from '@/utils/request'

const api = {
  pageQuery: "/order/pageQuery",
  findOrderDetail:"/order/findOrderDetail",
  writeInvoice:"/order/writeInvoice",
}

export default api

export function pageQuery(data){
  return request({
    url: api.pageQuery,
    method: 'post',
    data
  })
}

export function findOrderDetail(data){
  return request({
    url: api.findOrderDetail,
    method: 'post',
    data
  })
}

export function writeInvoice(data){
  return request({
    url: api.writeInvoice,
    method: 'post',
    data
  })
}
